import React from 'react';
import PropTypes from 'prop-types';
import { H3, Body1 } from '@xo-union/tk-ui-typography';
import { Button } from '@xo-union/tk-component-buttons';
import Modal from '@xo-union/tk-component-modals';
import Overlay from '@xo-union/tk-component-overlay';
import Spinner from '@xo-union/tk-component-spinner';
import {
  overlay,
  warningContainer,
  warningButtonContainer,
  warningButton,
  warningHeaderContainer,
  warningHeader,
} from './import-spreadsheet-overlay.scss';

export const ImportSpreadsheetWarningOverlay = ({ onConfirm, onCancel, showWarning }) => {
  if (!showWarning) return null;
  return (
    <Overlay className={overlay}>
      <Modal size="md" onClose={onCancel}>
        <div className={warningContainer}>
          <div className={warningHeaderContainer}>
            <H3 className={warningHeader}>Are you sure?</H3>
            <Body1>
              Your guests haven&#39;t been saved yet! Click &#34;Yes&#34; to continue without adding them to your list.
            </Body1>
          </div>
          <div className={warningButtonContainer}>
            <Button className={warningButton} onClick={onCancel} color="secondary" size="md">
              No
            </Button>
            <Button className={warningButton} onClick={onConfirm} size="md">
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </Overlay>
  );
};

ImportSpreadsheetWarningOverlay.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  showWarning: PropTypes.bool,
};

export const ImportSpreadsheetSpinnerOverlay = ({ isProcessing }) => {
  if (!isProcessing) return null;
  return (
    <Overlay className={overlay} color="light">
      <Spinner />
    </Overlay>
  );
};

ImportSpreadsheetSpinnerOverlay.propTypes = {
  isProcessing: PropTypes.bool,
};
